import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'STUDENT_ANALYTICS_GET',
  GET_SUCCESS: 'STUDENT_ANALYTICS_GET_SUCCESS',
  GET_FAILURE: 'STUDENT_ANALYTICS_GET_FAILURE',
};

export const get = actions.get(
  (studentId, queryObj) =>
    `${BASE_URL}/intelanalytics/student-list?${stringify(queryObj)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
